module.exports = __webpack_public_path__ + "static/media/1021464.c1a96347.jpg";